import React from 'react';
import styled from 'astroturf/react';
import { VerticalSpacer } from './VerticalSpacer';
import ErrorIcon from 'js/design_system/icons/error.svg';
import { Body } from 'js/design_system/Body';

// Rendered as a div (not the default <p>) since it contains the IconDiv block element.
const ErrorDiv = styled(Body).attrs({
  size: 'sm',
  as: 'div',
})`
  position: relative;
  display: inline-flex;
  padding: 16px 24px;
  align-items: center;
  gap: 8px;
  width: 100%;
  white-space: pre-line;

  border-radius: 16px;
  border: 1px solid var(--red-100, #b60000);
  background: var(--red-10, #fff2f2);

  color: var(--neutrals-900, #070a15);
`;

const IconDiv = styled.div`
  float: left;
  height: 24px;
  color: var(--red-100, #b60000);
`;

type Props = {
  show?: boolean;
  errorMessage?: string;
};

export const ModalError: React.FC<Props> = ({ show = true, errorMessage }) => {
  return show ? (
    <>
      <VerticalSpacer height={32} />
      <ErrorDiv>
        <IconDiv>
          <ErrorIcon />
        </IconDiv>
        {errorMessage ?? 'Something went wrong. Please try again.'}
      </ErrorDiv>
    </>
  ) : (
    <></>
  );
};
